export class ExpenseQuickEntryApiModel {

    public ExpenseQuickEntryID: number;
    public CategoryID: number;

    public ExpenseQuickEntryName: string;
    public ExpenseQuickEntryFullName: string;

    public ProductID: number;
    public ProductName: string;

    public AccountCodeDr: string;
    public AccountCodeCr: string;
    public AccountCodeNarration: string;

    public Narration: string;
public VendorID: number;
public VendorName: string;
    public IsActive: boolean;

    public UserID: number;
    public IsAvailableToPublic: boolean;

    public Created: Date;
    public Updated: Date;
}